import React from 'react';
import { useAuth } from '../context/AuthContext';
import AppRoutes from './AppRoutes';
import LoaderComponent from '../Elements/ids/Loader';

const Auth = () => {
  const { isAuthenticated, login, isLoading } = useAuth();

  if (isLoading) {
    return <LoaderComponent />;
  } else if (isAuthenticated) {
    return <AppRoutes />;
  } else {
    login();
    return null;
  }
};

export default Auth;
